import { render, staticRenderFns } from "./CombosPlusGeneradosImportAsignacion.vue?vue&type=template&id=f6633b82&scoped=true"
import script from "./CombosPlusGeneradosImportAsignacion.vue?vue&type=script&lang=js"
export * from "./CombosPlusGeneradosImportAsignacion.vue?vue&type=script&lang=js"
import style0 from "./CombosPlusGeneradosImportAsignacion.vue?vue&type=style&index=0&id=f6633b82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6633b82",
  null
  
)

export default component.exports